import type { FaireProductEntity } from "../../entity_types/product";

export const p_ccy2fz9v85: FaireProductEntity = {
  token: "p_ccy2fz9v85",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - CRIMSON",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/72e8a24e31cfba0ba571fcae48d9d8aad503d71412d6c3c301b10b26a913f150.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "This crimson bubble skirt from Girlie Girl Originals brings playful volume and feminine charm to wardrobe rotations. It pairs well with tees or dressier tops for styling and offers bold, fun appeal for casual occasions.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:30.730Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
